export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_green_p.d4525e3d.jpg";